import ajax from "../../authenticationSafeAjax";
import { contactWith } from "../contactsModels";

export function searchClientAddressBook(searchTerm, callback) {
    const request = {
        url: `/recorder/api/address-book?q=${searchTerm}`
    };

    ajax(request, (code, response) => {
        callback(JSON.parse(response).map(emailAddress => contactWith({ emailAddress })));
    });
}



/** WEBPACK FOOTER **
 ** ./src/main/javascript/contacts/actions/searchClientAddressBook.js
 **/